import { Shield } from 'lucide-react'

const Footer = () => {
  return (
    <footer className="bg-slate-950/80 backdrop-blur-xl text-white mt-auto border-t border-purple-700/60">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3">
        <div className="flex flex-col md:flex-row items-center justify-between gap-2 md:gap-0">
          {/* Left side - Copyright */}
          <div className="flex items-center space-x-2">
            <div className="w-8 h-8 bg-gradient-to-br from-purple-500 to-pink-500 rounded-full flex items-center justify-center p-1 shadow-md">
              <img
                src="/media/images/lumoralogo.png"
                alt="Spa~Radise Luxe Logo"
                className="w-full h-full object-contain"
              />
            </div>
            <div>
              <p className="text-sm text-gray-200">
                © {new Date().getFullYear()} Spa~Radise Luxe. All rights reserved.
              </p>
            </div>
          </div>

          {/* Right side - Admin Portal Info */}
          <div className="flex items-center space-x-2">
            <Shield className="w-4 h-4 text-purple-400" />
            <span className="text-sm text-gray-200">Admin management portal</span>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
